(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('resultats', resultats);

  function resultats($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/resultatapp/:idPartit', {idPartit: '@_idPartit'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());